import { DefaultSeo } from 'next-seo';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { HeadMeta } from '@/components/HeadMeta/HeadMeta';
import { SeoFullData } from '@/api/types/seo.types';
import { cleanupSeoUrl, makeUrlWithLang } from '@/utils/helpers';
import { CONFIG } from '@/constants/config';
import { getSeoTitle } from '@/components/Seo/Seo.helpers';

export const Seo = ({
  title,
  ogTitle,
  description,
  hostSum,
  jsonLd,
  image,
  noindex,
}: Partial<SeoFullData>) => {
  const { t, i18n } = useTranslation();
  const { asPath } = useRouter();
  const finalTitle = getSeoTitle(title, asPath, t);
  const finalOpenGraphTitle = getSeoTitle(ogTitle, asPath, t);
  const finalDescription = description || t('common.default_seo_description');

  const finalUrl =
    hostSum?.currentUrl ??
    makeUrlWithLang({
      protocol: CONFIG.protocol || '',
      host: CONFIG.host || '',
      path: '/',
      lang: i18n.language,
    });

  return (
    <>
      <HeadMeta currentUrl={finalUrl} noindex={noindex} jsonLd={jsonLd} />
      <DefaultSeo
        title={finalTitle}
        description={finalDescription}
        openGraph={{
          title: finalOpenGraphTitle,
          description: finalDescription,
          url: cleanupSeoUrl(finalUrl),
          siteName: 'tap.az',
          ...(image?.url && { images: [image] }),
        }}
        facebook={{
          appId: CONFIG.fbAppId,
        }}
      />
    </>
  );
};
